import React from 'react';
import CancelWaitCompleteTemplate from '../../components_membership_hotel/template/hotel/cancelWaitCompleteTemplate';
class CancelWaitComplete extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            reservationConfList: [],
            membershipReservationConfPopup : false,
            membershipReservationCancelPopup : false,
        };
    };

    render() {

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                membershipReservationConfPopup: true,
            });
            this.setState({reservationConfList: res.data});
            // common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({membershipReservationCancelPopup: true});
        }

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        reservationConfList: res.data,
                    }
                );
            }
        }

        return (
            <div>
                <CancelWaitCompleteTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                />
            </div>
        )
    }
}

let res = {
    data:{
        "resuleCode": "0",
        "errorMessage": "",
        "yoyakuNaiyoList": [
            {
                "checkInDate": "2022-06-06",
                "checkOutDate": "2022-06-08",
                "hakuCnt": 2,
                "shisetsuCd": "603",
                "shisetsuName": "テスト施設2",
                "machiFlg": "N",
                "planCd": "2000",
                "planName": "テストプラン2",
                "courseCd": "222",
                "courseName": "テストコース2",
                "roomCnt": "2",
                "yoyakuNo": "DEF77777",
                "paymentRyokin": "1000000",
                "roomList": [
                    {
                        "humanCount": 5,
                        "roomType": "部屋タイプ1",
                        "menCnt": 1,
                        "womenCnt": 1,
                        "childCnt": 1,
                        "preschoolerCnt": 1,
                        "babyCnt": 1
                    },
                    {
                        "humanCount": 5,
                        "roomType": "部屋タイプ2",
                        "menCnt": 2,
                        "womenCnt": 2,
                        "childCnt": 0,
                        "preschoolerCnt": 0,
                        "babyCnt": 1
                    }
                ],
                "foodList": [
                    {
                        "dayCnt":1,
                        "foodTimeList":[
                            {
                                "startTime": "20:00",
                                "jikantaiKbn": "夕食",
                                "restaurantCd": "333",
                                "restaurantName": "1日目レストラン夕食",
                                "courseList":[
                                    {
                                        "foodCourseCd": "101",
                                        "foodCourseName": "1日目夕食コース1",
                                        "targetCnt": 2
                                    },
                                    {
                                        "foodCourseCd": "201",
                                        "foodCourseName": "1日目夕食コース2",
                                        "targetCnt": 2
                                    },
                                    {
                                        "foodCourseCd": "301",
                                        "foodCourseName": "1日目夕食コース3",
                                        "targetCnt": 1
                                    }
                                ]
                            }                	
                        ]
                    },
                    {
                        "dayCnt":2,
                        "foodTimeList":[
                            {
                                "startTime": "07:00",
                                "jikantaiKbn": "朝食",
                                "restaurantCd": "333",
                                "restaurantName": "2日目レストラン朝食",
                                "courseList":[
                                    {
                                        "foodCourseCd": "101",
                                        "foodCourseName": "2日目朝食コース1",
                                        "targetCnt": 2
                                    },
                                    {
                                        "foodCourseCd": "201",
                                        "foodCourseName": "2日目朝食コース2",
                                        "targetCnt": 3
                                    }
                                ]
                            },
                            {
                                "startTime": "21:00",
                                "jikantaiKbn": "夕食",
                                "restaurantCd": "333",
                                "restaurantName": "2日目レストラン夕食",
                                "courseList":[
                                    {
                                        "foodCourseCd": "101",
                                        "foodCourseName": "2日目夕食コース1",
                                        "targetCnt": 5
                                    }
                                ]
                            }       	
                        ]
                    }
                ],
                "shokaKenriList": [
                    {
                        "dayCnt":1,
                        "shokaKenriIro": "white",
                        "riyoDate": "2022-06-07",
                        "shokaList": [
                            {
                                "shokaKenriIro": "red",
                                "syokaDate": "2022-08-10"
                            },
                            {
                                "shokaKenriIro": "gold",
                                "syokaDate": "2022-08-10"
                            }
                        ]
                    },
                    {
                        "dayCnt":2,
                        "shokaKenriIro": "gold",
                        "riyoDate": "2022-06-08",
                        "shokaList": [
                            {
                                "shokaKenriIro": "red",
                                "syokaDate": "2022-08-12"
                            },
                            {
                                "shokaKenriIro": "blue",
                                "syokaDate": "2022-08-13"
                            }
                        ]
                    }
                ]
            }
        ]
    }
}
export default CancelWaitComplete;